import { Component, OnInit, OnDestroy } from '@angular/core';
import { NotificationsService } from '../services/notifications.service';
import { LocationService } from '../../locations/services/location.service';
import { NotificationMessage, newNotificationMessage, LocationPicker } from '../notification.interfaces';
import { Subscription } from 'rxjs/Subscription';
import { NgForm } from '@angular/forms';
import { FormUtil } from '../../core/form.util';
import swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
const alertify = require('alertify.js');
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ch-sender',
  templateUrl: './sender.component.html',
  styleUrls: ['./sender.component.less'],
})
export class SenderComponent implements OnInit, OnDestroy {
  nothingSelectedMessage = 'Please select a location';

  sending = false;
  loading = true;
  topics: string[] = [];

  hasOffer = false;
  cardTitle;
  private offerId;

  message: NotificationMessage = newNotificationMessage();

  cities: LocationPicker[] = [];

  private cities$: Subscription;
  private sent$: Subscription;
  private params$: Subscription;

  constructor(private service: NotificationsService, private locations: LocationService, private route: ActivatedRoute, private titleService: Title) {
    alertify.logPosition('bottom right');
  }

  offerLabel(): string {
    return `Notifications for "${this.cardTitle}"`;
  }

  ngOnInit() {
    this.titleService.setTitle(`Send Notifications | CODE Hospitality CMS`);
    this.params$ = this.route.queryParamMap.subscribe(params => {
      this.offerId = params.get('offerId');
      this.cardTitle = params.get('cardTitle');
      if (this.offerId && this.cardTitle) {
        this.hasOffer = true;
      }
    });
    this.cities$ = this.locations
      .getLocationCities()
      .map(resp => resp.json())
      .map(locations =>
        locations.map(({ id, name }) => {
          const picker: LocationPicker = { id, value: name };
          return picker;
        })
      )
      .subscribe(cities => (this.cities = cities), _ => {}, () => (this.loading = false));
  }

  ngOnDestroy() {
    if (this.cities$) {
      this.cities$.unsubscribe();
    }
    if (this.sent$) {
      this.sent$.unsubscribe();
    }
    if (this.params$) {
      this.params$.unsubscribe();
    }
    this.titleService.setTitle(`CODE Hospitality CMS`);
  }

  send(form: NgForm) {
    if (this.topics.length === 0) {
      alertify.error('At least one city needs to be selected');
      FormUtil.isValid(form);
    } else if (FormUtil.isValid(form)) {
      swal({
        title: 'Are you sure you want to send this notification?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: false,
      }).then(result => {
        if (!result.value) {
          return;
        }
        if (this.sent$) {
          this.sent$.unsubscribe();
        }
        this.sending = true;
        this.sent$ = (this.hasOffer
          ? this.service.advertiseOffer(this.offerId, this.message, this.topics)
          : this.service.sendNotification(this.message, this.topics)
        ).subscribe(
          () => {
            this.topics = [];
            this.message = newNotificationMessage();
            swal('Congratulations', 'Notification sent successfuly', 'success');
          },
          _ => {
            swal('Fail', `Couldn't sent the notification`, 'error');
            this.sending = false;
          },
          () => {
            Object.keys(form.controls).forEach(key => {
              form.controls[key].markAsUntouched();
              form.controls[key].markAsPristine();
            });
            this.sending = false;
          }
        );
      });
    }
  }

  updateBody(newBody: string) {
    this.message.body = newBody;
  }

  locationAdded(event): void {
    if (!event || typeof event !== 'string') {
      return;
    } else if (this.topics.indexOf(event) < 0) {
      this.topics.push(event);
    }
  }

  selectedCities(): LocationPicker[] {
    return this.cities.filter((city: LocationPicker) => this.topics.indexOf(city.id) >= 0);
  }

  removeCity(id: string): void {
    const index = this.topics.indexOf(id);
    this.topics.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/notifications/sender/sender.component.ts